<!-- 
  - is loginstatus is found in localstorage we dont see this page
  - First Page of Enertics Website if we have not loggedIn and No informationis stored in LocalStorage
  - goToLogin() when login button clicked redirects user to login page
  - Commented by Sarthak on Feb 12, 2024
 -->
 <div class="landing_banner_outer">
  <div class="landing_banner_cg" *ngIf="Cgkey">
    <div class="banner_cover">
      <div class="caption_text">
        <div class="bannerLogoWrap">
          <!-- <img *ngIf="DSPkey" src="assets/img/brand/sailogo.png" width="125" />
          <img src="assets/img/brand/enertics_logo_white_05x.png" /> -->
        </div>
        <img
          style="height: 100px; width: 100px"
          src="assets/img/brand/cg.png"
        />
        <h2>
          Unlocking the power of IoT and Machine Learning Technologies to
          provide an end-to-end Asset Performance Management solution
        </h2>
        <button class="btn" mat-raised-button (click)="goToLogin()">
          Log In
        </button>
      </div>
    </div>
  </div>

  <div class="landing_banner" *ngIf="!Cgkey">
    <div class="banner_cover">
      <div class="caption_text">
        <div class="bannerLogoWrap">
          <img *ngIf="DSPkey" src="assets/img/brand/sailogo.png" width="125" />
          <img src="assets/img/brand/enertics_logo_white_05x.png" />
        </div>
        <h2>
          Unlocking the power of IoT and Machine Learning Technologies to
          provide an end-to-end Asset Performance Management solution
        </h2>
        <button class="btn" mat-raised-button (click)="goToLogin()">
          Log In
        </button>
      </div>
    </div>
  </div>
</div>
<div class="Bgimage" *ngIf="underMaintenance" style="padding: 0; margin: 0;">
  <img
    class="image"
    src="https://www.inovia.vc/wp-content/uploads/2021/11/1GtjXXJ_0aZFYlAyYniCvDQ.jpeg"
  />
  <div class="centered">
    <img src="/assets/images/enertics_logo_white_05x.png" />
  </div>
  <div class="up">
    <img src="/assets/images/danger-removebg-preview.png" />
  </div>
  <div
    class="text"
    style="border: solid 0px #000000; padding: 20px; text-align: center"
  >
    <h3>
      <b
        >We're currently undergoing maintenance to enhance your experience.
        Please bear with us, and we will be back online shortly after {{endDateDay}} {{endDateHr}}.
        Thank you for your patience!"</b
      >
    </h3>
  </div>
</div>
